import * as prismic from "@prismicio/client";
import { PrismicRichText } from "@/components/PrismicRichText";
import { PrismicNextImage } from "@prismicio/next";
import { Icon } from "@iconify/react";
import { useState, Fragment } from "react";
import {
  Dialog,
  Transition,
  TransitionChild,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";

const CakeFlavour = ({ flavour }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <div className="flex flex-col w-full text-left">
      <div className="relative w-full">
        <div onClick={openModal} className="cursor-pointer">
          <PrismicNextImage
            field={flavour.image}
            width={900}
            height={400}
            loading="lazy"
          />
        </div>

        <h3
          className="absolute flex font-serif font-normal tracking-tight text-3xl bottom-0 m-4 mb-0 px-2 py-3 bg-white/45 items-center w-full text-left"
          style={{ width: "calc(100% - 35px)" }}
        >
          {prismic.asText(flavour.name)}
        </h3>
      </div>

      <div className="mt-4">
        <PrismicRichText field={flavour.description} />
      </div>

      <div className="text-sm mt-4">
        <strong>Allergens:</strong>
        <br />
        {prismic.asText(flavour.allergens)}
      </div>

      {/* Modal (Lightbox) */}
      <Transition appear show={isOpen} as={Fragment}>
        <Dialog
          open={isOpen}
          onClose={closeModal}
          className="fixed inset-0 z-50 overflow-y-auto"
        >
          <div className="flex items-center justify-center min-h-screen">
            <TransitionChild
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div
                className="fixed inset-0 bg-black bg-opacity-80"
                onClick={closeModal}
              />
            </TransitionChild>

            <button
              onClick={closeModal}
              className="absolute top-1 right-1 p-2 bg-transparent"
            >
              <Icon icon="mingcute:close-fill" className="w-6 h-6 text-white" />
            </button>
            <TransitionChild
              as={Fragment}
              enter="transition ease-in-out duration-300 transform"
              enterFrom="scale-95 opacity-0"
              enterTo="scale-100 opacity-100"
              leave="transition ease-in-out duration-300 transform"
              leaveFrom="scale-100 opacity-100"
              leaveTo="scale-95 opacity-0"
            >
              <div className="relative mx-auto w-full md:max-w-6xl">
                <PrismicNextImage
                  field={flavour.image}
                  alt={prismic.asText(flavour.name)}
                  sizes="(min-width: 1024px) 800px, 90vw"
                  className="w-full h-full"
                />
              </div>
            </TransitionChild>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
};

export default CakeFlavour;
